<mat-toolbar class="mat-elevation-z8 animated fadeIn fast" [class.side-nav-open]="opened" [class.side-nav-closed]="!opened">
    <div class="animated fadeIn fast"> {{ title }} </div>
    <span class="spacer"></span>
    <div class="header-buttons">
        <ng-content class="buttons" select=".buttons">

        </ng-content>
    </div>
</mat-toolbar>
